import { Typography } from 'antd';
import AppSearchInput from 'components/AppSearchInput';
import { useModalState } from 'hooks/useModalState';
import { noop } from 'lodash';
import React, { useState } from 'react';
import PFileModalPayment from './PFileModalPayment';

export type PFileSelectInputType = {
  pfid?: string;
};

export type PFileSelectInputProps = {
  onChange?: any;
  value?: PFileSelectInputType;
};

const InputFilePayment = ({
  onChange = noop,
  value,
}: PFileSelectInputProps) => {
  const [Params, setParams] = useState<any>();

  const { visible, close, open } = useModalState(false);
  const handleSelect = (item: any) => {
    onChange(item);
    setParams(item);

    close();
  };

  return (
    <>
      <AppSearchInput
        onSearch={open}
        value={
          <Typography.Link>
            {!value
              ? Params
                ? `File : ${Params ?? ''} `
                : 'Select Payment File'
              : value
              ? `File : ${Params ?? ''} `
              : 'Select Payment File'}
          </Typography.Link>
        }
      />
      <PFileModalPayment
        visible={visible}
        onCancel={close}
        onChange={handleSelect}
      />
    </>
  );
};

export default InputFilePayment;
